import { MutableRefObject } from 'react';
import { validateEslMac } from '@/mobile/utils/mobileUtils';
import { decodeMac, encodedMACFormat } from '@/utils/inputUtils';
import { ButtonInfo } from '../provider/state';
import { ScannerInputFieldRef } from '../components/ScannerInputField';

type CreateEslInputHandlerOptions = {
    isSubmitting?: boolean;
    setESL: (value: string) => void;
    setButtonInfo: (status: ButtonInfo) => void;
    onInvalid?: () => void | Promise<void>;
    onValid: (finalMac: string) => void | Promise<void>;
    eslMacInputRef?: MutableRefObject<ScannerInputFieldRef | null>;
};

const normalizeEslMac = (raw: string) => {
    return encodedMACFormat(raw) ? decodeMac(raw.substring(2)) : raw;
};

export const createEslInputHandler = ({
    isSubmitting = false,
    setESL,
    setButtonInfo = () => {},
    onInvalid,
    onValid,
    eslMacInputRef,
}: CreateEslInputHandlerOptions) => {
    const onError = () => {
        setESL('');
        setButtonInfo({ type: 'error', msg: 'Invalid ESL MAC. Re-Scan.' });
    };

    return async (raw: string) => {
        const trimmed = raw.trim();
        if (!trimmed) return;
        if (isSubmitting) return;

        if (!validateEslMac(trimmed)) {
            onError();
            if (onInvalid) await onInvalid();
            return;
        }

        const finalMac = normalizeEslMac(trimmed);
        setESL(finalMac);

        if (!eslMacInputRef) {
            //console.log('No input ref provided, skipping readonly state');
            await onValid(finalMac);
            return;
        }

        await onValid(finalMac);
    };
};
